// src/i18n/es/channels.ts
// Single, canonical channel vocabulary (Decision 13 of the hotel-operations
// redesign). Every screen must read channel labels from here (via
// design/registry/channelRegistry.ts), never from a page-local dictionary.
export const channels = {
  online: 'Pre-check-in online',
  kiosk: 'Kiosco',
  airLobby: 'Air Lobby',
  mobileKiosk: 'Kiosco en el móvil',
  dispenser: 'Dispensador de llaves',
  none: 'Sin canal',

  short: {
    online: 'Online',
    kiosk: 'Kiosco',
    airLobby: 'Air Lobby',
    mobileKiosk: 'Móvil',
    dispenser: 'Dispensador',
  },
};

export default channels;
